import React from "react";
import { Link } from "react-router-dom";

const iconUrl = new URL('../assets/katpack_icon_64.png', import.meta.url).href;

export function NavBar({ config }) {
  return (
    <nav className="bg-gray-800 border-b border-gray-700 px-6 py-3 flex items-center justify-between">
      <Link to="/" className="flex items-center gap-2 font-bold text-lg text-white">
        <img src={iconUrl} alt="KatPack" className="w-8 h-8 object-contain" />
        <span>KatPack.ai</span>
      </Link>

      <div className="flex items-center gap-4">
        <a href={config.docsUrl} className="hover:text-gray-400 underline text-white text-sm" target="_blank" rel="noreferrer">
          Docs
        </a>
      </div>
    </nav>
  );
}
